<form class="form" [formGroup]="loginForm" (submit)="doLogin()">
  <h2>Entrar</h2>
  <p>Digite suas credenciais para acessar o sistema.</p>
  <div class="row my-4">
    <div class="col">
      <label>E-mail:</label>
      <input
        formControlName="email"
        class="input form-control"
        type="email"
        name="email"
        placeholder="nome@email.com"
      />
    </div>
    <div
      class="message-error"
      *ngIf="
        loginForm.get('email')?.errors?.required &&
        loginForm.get('email')?.touched
      "
    >
      Campo Obrigatório
    </div>
    <div
      class="message-error"
      *ngIf="
        loginForm.get('email')?.errors?.email && loginForm.get('email')?.touched
      "
    >
      Formato Inválido
    </div>
  </div>
  <div class="row my-4">
    <div class="col">
      <label class="password-label">
        <span> Senha: </span>
        <a routerLink="redefinir-senha"> Esqueceu sua senha? </a>
      </label>
      <input
        formControlName="senha"
        class="input form-control"
        type="password"
        name=""
        placeholder="********"
      />
    </div>
  </div>
  <div class="row my-5">
    <div class="col">
      <div>
        <button class="form-button button-primary">Entrar</button>
      </div>
    </div>

 <!-- Aviso de Horário Especial -->
<div
  *ngIf="environment.company === 'km-do-brasil' && showDateAlert"
  class="alert-card alert-warning mt-4"
>
  <div class="alert-header">
    <i class="alert-icon">📅</i>
    <h4 class="alert-title">Aviso sobre Horário de Expediente</h4>
  </div>
  <p class="alert-content">
    Prezados Clientes:
  </p>
  <ul class="alert-list">
    <li *ngFor="let workDate of workTimeDate">{{ workDate }}</li>
  </ul>
  <p class="alert-footer">Agradecemos à compreensão.</p>
</div>

    <!-- Aviso de Conta Não Migrada -->
    <div
      *ngIf="environment.company === 'km-do-brasil'"
      class="alert-card alert-info mt-4"
    >
      <div class="alert-header">
        <i class="alert-icon">⚠️</i>
        <h4 class="alert-title">Importante sobre Acesso</h4>
      </div>
      <p class="alert-content">
        Olá! Se a sua conta ainda não foi criada, por favor, entre em contato
        via WhatsApp. Devido a mudança de versionamento nem todas as contas de
        nosso antigo Portal foram migradas. Pedimos desculpas pelo transtorno.
        <a
          href="https://wa.me/5519994748070?text=Ol%C3%A1%21%20Preciso%20de%20suporte%20com%20o%20portal."
          target="_blank"
        >
          +55 19 99474-8070
        </a>
        para assistência imediata.
      </p>
    </div>
  </div>
</form>
